import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import $ from "jquery";
import CourseApplyForm from "./../forms/apply_form";
import { getSingleRoute } from "../../../common/utils";
import { getQueryString, slugSet } from "../../common/getQueryString";

function InstituteCard(props) {
	const [applyCourse, setApplyCourse] = useState(null);
	const history = useHistory()
	function clickApplyForm(course) {
		if (localStorage.getItem("user_Id")) {
			$("#applyModal").modal("show");
			setApplyCourse(course);
		} else {
			$("#login").modal("show");
		}
	}
	const InstituteRankingTableDataView = ({ rankings, ranking_type }) => {
		if (rankings) {
			for (const ranking of rankings) {
				if (ranking.ranking_type === ranking_type) {
					if (ranking.value) {
						return <span key={"value"}>{ranking.value}</span>;
					}
				}
			}
		}
		return <span key={"empty"}>{"N/A"}</span>;
	};
	const getRoute = (page, id) => {
        getSingleRoute(page).then(d => {
            history.push({
                pathname: d + `${id?.id ? '/' + id?.id : ''}`,
                search: id?.search?id?.search:'',
            });
        })
    }
	return (
		<div className="fullWidth">
			<div className="courseFlex" key="main">
				{props.data ? (
					props.data.map((item, index) => (
						<div className="courseBox instituteBox" key={index}>
							<div className="imgWrap" key="imgWrap">
								<img
									src="https://assets.timescoursefinder.com/Media/cb4.svg"
									alt="uni-background"
								/>
								<div className="courseBoxTop" key="courseBoxTop">
									<button
									onClick={()=>getRoute('university_details',{
										id:`${slugSet(item.slug)}${slugSet(item.campus_slug)}`
										// id:`${slugSet(item.slug)}${slugSet(item.course_slug)}${slugSet(item.degree_level_slug)}${slugSet(item.discipline_slug)}${slugSet(item.country_slug)}${slugSet(item.campus_slug)}`
										// search: $.param({
										// 	institute_id: item.id,
										// 	institute_name: item.institute_name,
										// })
									})}
										// to={{
										// 	pathname: "/university-details/",
										// 	search: $.param({
										// 		institute_id: item.id,
										// 		institute_name: item.institute_name,
										// 	}),
										// }}
									>
										<img src={item.logo} alt={item.institute_name} width={'100px'}/>
									</button>
									<div key={"courseBoxTop1"}>
										<button
										onClick={()=>getRoute('university_details',{
										id:`${slugSet(item.slug)}${slugSet(item.campus_slug)}`
										// id:`${slugSet(item.slug)}${slugSet(item.course_slug)}${slugSet(item.degree_level_slug)}${slugSet(item.discipline_slug)}${slugSet(item.course_slug)}${slugSet(item.campus_slug)}`
											// search: $.param({
											// 	institute_id: item.id,
											// 	institute_name: item.institute_name,
											// })
										})}
											// to={{
											// 	pathname: "/university-details/",
											// 	search: $.param({
											// 		institute_id: item.id,
											// 		institute_name: item.institute_name,
											// 	}),
											// }}
										>
											<h6>{item.institute_name}</h6>
										</button>
										{props?.country?.name ? <p>{props.country.name}</p> : ""}
									</div>
								</div>

								{/* <div className="btnGroup" key="btnGroup">
								<p className="views">
									<img
										src={
											require("../../../static/images/visibility.svg").default
										}
										alt="view-img"
									/>{" "}
									25681,251 views
								</p> */}
								{/* <button className="btn">
						<img
							src={require("../../../static/images/fav-purple.svg").default}
							alt="course-img"
						/>
					</button> */}
								{/* </div> */}
							</div>
							<div key="1" className="courseBoxCont">
								<div key={"courseBoxCont"}>
									<div key="courseBoxCont2">
										<p>Campus</p>
										<p>Ranked by QS</p>
										<p>Ranked by THE</p>
										<button
										className="tran-button"
										onClick={()=>getRoute('university_details',{
										id:`${slugSet(item.slug)}${slugSet(item.campus_slug)}`
										// id:`${slugSet(item.slug)}${slugSet(item.course_slug)}${slugSet(item.degree_level_slug)}${slugSet(item.discipline_slug)}${slugSet(item.course_slug)}${slugSet(item.campus_slug)}`

											// search: $.param({
											// 	institute_id: item.id,
											// 	institute_name: item.institute_name,
											// })
										})}
											// to={{
											// 	pathname: "/university-details/",
											// 	search: $.param({
											// 		institute_id: item.id,
											// 		institute_name: item.institute_name,
											// 	}),
											// }}
										>
											<p style={{ color: "#3F2566" }}>
												<img
													src={
														require("../../../static/images/bachelor_honors.svg")
															.default
													}
													alt="bachelor_honors"
												/>
												Programs
											</p>
										</button>
									</div>
									<div key={"campus"}>
										<p className="campusNameCrop">
											{item.campuses ? (
												item.campuses.map((subItem, index) => (
													<span key={index}>{subItem.campus},</span>
												))
											) : (
												<span key={"no_record"}>No campus</span>
											)}
										</p>
										<p>
											<InstituteRankingTableDataView
												ranking_type="qs_world_ranking"
												rankings={item.institute_ranking}
											/>
										</p>
										<p>
											<InstituteRankingTableDataView
												ranking_type="times_higher_world_ranking"
												rankings={item.institute_ranking}
											/>
										</p>
										<button
										className="tran-button"
										onClick={()=>getRoute('institute_scholarships',{
											search: getQueryString({
												institutes: [item.slug],
												country: [props.country.slug],
											})
										})}
											// to={{
											// 	pathname: "/institute-scholarships",
											// 	search: $.param({
											// 		institute_id: item.id,
											// 		institute_name: item.institute_name,
											// 		country_id: props.country.id,
											// 	}),
											// }}
										>
											<p style={{ color: "#3F2566" }}>
												<img
													src={
														require("../../../static/images/schol-icon3.svg")
															.default
													}
													alt="course-img"
												/>
												Scholarships
											</p>
										</button>
									</div>
								</div>
								<div
									key="2"
									className="btnGroup"
									onClick={(e) => clickApplyForm(e)}
								>
									<button className="btn">Apply Now</button>
								</div>
							</div>
						</div>
					))
				) : (
					<h4 style={{ textAlign: "center" }}>Record not found</h4>
				)}
				<div
					className="modal signinModal fade"
					id="applyModal"
					tabIndex="-1"
					role="dialog"
					aria-labelledby="applyModalLabel"
					aria-hidden="true"
				>
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							{/* <div className="modal-header">
							<h5 className="modal-title" id="requestInfoModalLabel">
								Apply Form
							</h5>
							<button
								type="button"
								className="close"
								data-dismiss="modal"
								aria-label="Close"
							>
								<span aria-hidden="true">&times;</span>
							</button>
						</div> */}
							<div className="modal-body">
								<button
									type="button"
									className="close"
									data-dismiss="modal"
									id="login_modal_close_btn"
									aria-label="Close"
								>
									<img
										src={
											require("../../../static/images/modal-times.svg").default
										}
										alt="modal-times"
									/>
								</button>
								<CourseApplyForm course={applyCourse} />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default InstituteCard;
